import { ChangeDetectionStrategy, Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EditPanelComponent } from '@Work/Accounts/proprietary/controls/form-controls/edit-panel/edit-panel.component';
import { DocumentObjectService } from '@Core/models/proprietary/document/document-object.service';

@Component({
    standalone: false,
    selector: 'ep-document-filing-edit-panel',
    templateUrl: './document-filing-edit-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentFilingEditPanelComponent extends EditPanelComponent implements OnInit, OnDestroy {
    ignorePageState = true; // overrides automatic readonly, error display mode from page state
    readOnlyMode = false; //override readonly mode

    //@Input()
    //taskActionOptions: any = {}

    @Input()
    set filing(value: any) {
        this.setFormData(value);
    }

    @Input()
    firstRow: boolean = null;

    constructor(private documentOS: DocumentObjectService, private injector: Injector) {
        super(injector);

        this.form = new UntypedFormGroup(
            {
                Filing: this.fb.group({
                    DocLink_ID: [''],
                    Selected_Ind: [''],
                    Edit_Status: [''],
                    Public_Document_Ind: [''],
                    File_External_Ind: [''],
                    Filing_Date: [''],
                    File_Drawer: [''],
                    File_Folder: [''],
                    Entity: this.fb.group({
                        Entity_ID: [''],
                        Entity_Name: [''],
                        Role_Type: ['']
                    }),
                    Contract: this.fb.group({
                        Contract_ID: [''],
                        Contract_Num: [''],
                        Eff_Date: ['']
                    }),
                    Claim: this.fb.group({
                        Claim_ID: [''],
                        Book_Claim_Num: ['']
                    })
                })
            },
            { updateOn: 'blur' }
        );
    }

    ngOnInit() {
        super.ngOnInit(); // TODO!! this is problematic -- if we forget this things don't work -- same problem for ngDestroy!!!    
        // Perhap extends is NOT a good solution.   A service?'
        this.formChangeSub = this.form.valueChanges.subscribe((value) => {
            this.documentOS.updateFiling(this.form.getRawValue().Filing);
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        //if (this.taskSub) this.taskSub.unsubscribe();
    }

    applyRules() {
        let newFiling = false;
        // console.log(`doc filing applyRules(): rawValue = ${JSON.stringify(this.form.getRawValue())}`);
        if (this.form.getRawValue().Filing.Edit_Status == 'A') {
            newFiling = true;
        }

        this.disableControl('Filing', !newFiling);
    }

    setFormData(value: any) {
        if (value) {
            this.form.controls.Filing.patchValue(value, { emitEvent: false });
            this.applyRules();
        }
    }

    getFilingTooltip() {
        let filing = this.getControlValue('Filing');
        let role = this.getObjectInfo('Entity' + filing.Entity.Role_Type).Object_Desc;
        let tooltip = role + ': ' + filing.Entity.Entity_Name;
        if (filing.Contract && filing.Contract.Contract_ID > 0) {
            tooltip = tooltip + ' / Contract: ' + filing.Contract.Contract_Num;
        }
        if (filing.Claim && filing.Claim.Claim_ID > 0) {
            tooltip = tooltip + ' / Claim: ' + filing.Claim.Book_Claim_Num;
        }
        return tooltip;
    }

    getRoleIcon() {
        let objectCode = 'Entity' + this.getControlValue('Filing.Entity.Role_Type');
        return this.getObjectInfo(objectCode).Icon;
    }

    getObjectInfo(objectCode: string): any {
        //TODO: HACK  Create global function to get object info
        let objectInfo = {
            Object_Code: objectCode,
            Object_Desc: 'Unknown',
            Tooltip: '',
            Icon: 'fa-ep-unknown'
        };

        if (objectCode) {
            if (objectCode.toLowerCase().startsWith('entity')) {
                objectInfo.Object_Desc = 'Entity';
                objectInfo.Tooltip = 'Entity';
                objectInfo.Icon = 'fa-ep-entity';
            }

            switch (objectCode.toLowerCase()) {
                case 'entitysp':
                    objectInfo.Icon = 'unity-icon-building';
                    objectInfo.Object_Desc = 'Supplier';
                    objectInfo.Tooltip = 'Supplier';
                    break;
                case 'entitycn':
                    objectInfo.Icon = 'unity-icon-user';
                    objectInfo.Object_Desc = 'Consumer';
                    objectInfo.Tooltip = 'Consumer';
                    break;
                case 'entitybk':
                    objectInfo.Icon = 'unity-icon-briefcase';
                    objectInfo.Object_Desc = 'Broker';
                    objectInfo.Tooltip = 'Broker';
                    break;
                case 'entityem':
                    objectInfo.Icon = 'unity-icon-employee';
                    objectInfo.Object_Desc = 'Employee';
                    objectInfo.Tooltip = 'Employee';
                    break;
                case 'entitycl':
                    objectInfo.Icon = 'fa-ep-entity-claimant';
                    objectInfo.Object_Desc = 'Claimant';
                    objectInfo.Tooltip = 'Claimant';
                    break;
                case 'enititybo':
                    objectInfo.Icon = 'fa-ep-entity-book';
                    objectInfo.Object_Desc = 'Book';
                    objectInfo.Tooltip = 'Book';
                    break;
            }
        }
        return objectInfo;
    }
}
